import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import StyledModal from '../StyledModal';
import style from '../../style/components/signin/CloseAccountModal.module.scss';
import { useSelector } from 'react-redux';
import AccountDeleteModal from './AccountDeleteModal';

const CloseAccountWarning = () => {
  const { t } = useTranslation();

  return (
    <div className={style.warning}>
      <idme-icon name="alert-triangle" />
      <div>
        <h3>{t('account.close.heading_govBenefits')}</h3>
        <p>
          <Trans
            i18nKey="account.close.notice_govBenefitsModal"
            components={{ strong: <strong /> }}
          />
        </p>
      </div>
    </div>
  );
};

const CloseAccountModal = ({ closeModal, isOpen }) => {
  const { t } = useTranslation();

  const hasStateWorkforceCredential = useSelector(
    (state) => state.user.workforce_credential,
  );

  const [isAccountDeleteModalOpen, setIsAccountDeleteModalOpen] =
    useState(false);

  const privacyLink = <a href="https://www.id.me/privacy">Privacy Policy</a>;
  const termsLink = <a href="https://www.id.me/terms">Terms of Service</a>;
  const learnMoreLink = (
    <a href="https://help.id.me/hc/en-us/articles/203532014">
      learn about account closure
    </a>
  );
  const supportLink = (
    <a href="https://help.id.me/hc/en-us/requests/new">
      contact our Support Team
    </a>
  );

  return (
    <>
      <StyledModal
        isOpen={isOpen}
        closeModal={closeModal}
        title={t('account.close.title')}
        primaryButton={{
          text: t('common.button_continue'),
          action: () => {
            setIsAccountDeleteModalOpen(true);
            closeModal();
          },
        }}
      >
        <p>
          <Trans
            i18nKey="account.close.description_retentionWithLearnMore"
            components={{ privacyLink, termsLink, learnMoreLink }}
          />
        </p>

        {hasStateWorkforceCredential && <CloseAccountWarning />}

        <div className={style.background}>
          <strong>{t('account.close.notice_needHelp')}</strong>
          <p>
            <Trans
              i18nKey="account.close.description_supportModal"
              components={{ supportLink }}
            />
          </p>
        </div>
      </StyledModal>
      <AccountDeleteModal
        isOpen={isAccountDeleteModalOpen}
        closeModal={() => setIsAccountDeleteModalOpen(false)}
      />
    </>
  );
};

export default CloseAccountModal;
